import React from 'react';

const Section = ({ n, title, children }) => (
  <div className="text-left mt-8">
    <div className="font-mono-r text-[10px] tracking-[0.4em] uppercase opacity-60">§ {n}</div>
    <h3 className="font-display text-3xl mt-1">{title}</h3>
    <div className="font-mono-r text-sm mt-3 leading-relaxed opacity-90 space-y-3">
      {children}
    </div>
  </div>
);

export default function Terms() {
  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Legal  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">TERMS</h1>
      <p className="font-mono-r text-xs tracking-[0.25em] uppercase opacity-70 mt-3">
        Last updated · 11 February 2026
      </p>
      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      <div className="max-w-2xl w-full">
        <Section n="01" title="Agreement">
          <p>
            By using the OSO London website, audio stream or Alexa skill
            (&ldquo;the Service&rdquo;) you agree to these Terms. If you do not agree,
            please don&apos;t use the Service.
          </p>
        </Section>

        <Section n="02" title="The Service">
          <p>
            OSO London provides a free, ad-free, 24-hour internet radio
            stream and related programming information. The Service is
            offered on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis. We may change
            programming, schedules or take the stream offline for
            maintenance without notice.
          </p>
        </Section>

        <Section n="03" title="Music & Copyright">
          <p>
            All music broadcast on OSO London is the property of its
            respective copyright holders. We hold the public-performance
            licences required to broadcast it via internet radio in the
            United Kingdom (PRS for Music, PPL).
          </p>
          <p>
            You may listen to the stream but you may not re-broadcast,
            re-stream, record or redistribute it without our written
            permission.
          </p>
        </Section>

        <Section n="04" title="Alexa Skill">
          <p>
            The OSO London Alexa skill is provided free of charge to play
            our live stream on Alexa-enabled devices. Your use of Alexa is
            additionally governed by Amazon&apos;s own terms of service. We
            don&apos;t store the requests Alexa sends us.
          </p>
        </Section>

        <Section n="05" title="Acceptable Use">
          <p>
            Don&apos;t attempt to disrupt, overload or reverse-engineer the
            Service, or use it to harass any person.
          </p>
        </Section>

        <Section n="06" title="Liability">
          <p>
            To the extent permitted by law, OSO London is not liable for
            indirect or consequential losses arising from your use of the
            Service. Nothing in these Terms limits liability for fraud or
            for death or personal injury caused by negligence.
          </p>
        </Section>

        <Section n="07" title="Governing Law">
          <p>
            These Terms are governed by the laws of England and Wales.
            Disputes will be heard in the courts of England and Wales.
          </p>
        </Section>

        <Section n="08" title="Contact">
          <p>
            <a className="underline" href="mailto:info@osolondon.com">info@osolondon.com</a>
          </p>
        </Section>
      </div>
    </section>
  );
}
